export enum ViewMode {
  EditData = 1,
  SortItems = 2,
}
